import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_available_inventory_by_licenseplateId_lotIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lotId: number, licenseplateId: number, eligibleForAllocationCheck?: boolean }): 
  Promise<{ result: { TotalAvailablePackagedAmount?: number, TotalAvailableBaseAmount?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lotId)) {
      $missingRequiredInParams.push('\'lotId\'');
    }
    if (isNil($inParams.licenseplateId)) {
      $missingRequiredInParams.push('\'licenseplateId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lotId: number, licenseplateId: number, eligibleForAllocationCheck?: boolean    }) {
        if(isNil($inParams.lotId)) {
          return true; 
        }
        if(isNil($inParams.licenseplateId)) {
          return true; 
        }
      return false;
    }
}
